export enum ScrapConsumptionSelector {
  PATH = 'PATH',
  MATCHER = 'MATCHER',
}
